import { useEffect, useState } from "react";
import { Scale } from "lucide-react";
import { getBalance } from "@/lib/scoutApi";

const Bar = ({ label, b, target }) => {
  if (!b || !b.total) {
    return (
      <div className="flex items-center gap-3 text-xs text-slate-400">
        <span className="w-24 shrink-0">{label}</span>
        <span>—</span>
      </div>
    );
  }
  const ok = b.pct >= target;
  return (
    <div className="text-xs" data-testid={`balance-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="flex items-center justify-between mb-1">
        <span className="text-slate-600">{label}</span>
        <span className={ok ? "text-[#0A192F] font-medium" : "text-red-600 font-medium"}>
          {b.pct}% adversarial · {b.adversarial}/{b.total}
        </span>
      </div>
      <div className="h-2 w-full bg-slate-200 relative">
        <div className={`h-2 ${ok ? "bg-[#0A192F]" : "bg-red-500"}`} style={{ width: `${b.pct}%` }} />
        <div className="absolute top-[-3px] h-[14px] w-px bg-[var(--accent)]" style={{ left: `${target}%` }} title={`Target ${target}%`} />
      </div>
    </div>
  );
};

export const BalanceMeter = ({ refreshKey }) => {
  const [b, setB] = useState(null);
  useEffect(() => {
    getBalance().then(setB).catch(() => setB(null));
  }, [refreshKey]);
  if (!b) return null;
  const shown = [b.featured, b.booked].filter((x) => x && x.total);
  const below = shown.some((x) => x.pct < b.target_pct);
  const noData = shown.length === 0;
  return (
    <section data-testid="scout-balance" className="border-t border-slate-200 pt-8">
      <div className="text-xs tracking-tight text-[var(--accent)] mb-1 flex items-center gap-2">
        <Scale className="w-3.5 h-3.5" /> Balance Meter · target ≥ {b.target_pct}% adversarial
      </div>
      <p data-testid="scout-balance-verdict" className={`text-sm mb-4 ${below ? "text-red-600" : "text-slate-600"}`}>
        {noData
          ? "Feature or book someone to start measuring what the audience actually sees."
          : below
            ? "What the audience sees is drifting toward an echo chamber — feature or book adversarial voices."
            : "Healthy friction. What the audience sees and what airs skews toward people who disagree with you."}
      </p>
      <div className="space-y-3">
        <Bar label="Whole CRM" b={b.all} target={b.target_pct} />
        <Bar label="New this week" b={b.new_this_week} target={b.target_pct} />
        <Bar label="Shortlisted" b={b.shortlisted} target={b.target_pct} />
        <Bar label="Contacted" b={b.contacted} target={b.target_pct} />
        <Bar label="Booked" b={b.booked} target={b.target_pct} />
        <Bar label="Featured" b={b.featured} target={b.target_pct} />
      </div>
    </section>
  );
};

export default BalanceMeter;
